import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import auth from '@/store/modules/auth'
import shared from '@/store/modules/shared/index'
import address from '@/store/modules/address/index'
import shipping from '@/store/modules/shipping/index'
import product from '@/store/modules/product/index'
import cart from '@/store/modules/cart/index'
import order from '@/store/modules/order/index'
import claim from '@/store/modules/claim/index'
import notification from '@/store/modules/notification/index'
import favorite from '@/store/modules/favorite/index'
import user from '@/store/modules/user/index'
import websocket from '@/store/modules/websocket/index'
import file from '@/store/modules/file'
import tracker from '@/store/modules/tracker'
import theme from '@/store/modules/theme'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['auth', 'cart']
})

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {},
  modules: {
    auth,
    shared,
    address,
    shipping,
    product,
    cart,
    order,
    claim,
    notification,
    favorite,
    user,
    websocket,
    file,
    tracker,
    theme
  },
  plugins: [vuexLocal.plugin]
})
